import axios from 'axios';
import { API_URL } from './Constant';

const userToken = localStorage.getItem('access_token');

export const axiosConfig = axios.create({
    baseURL: API_URL,
    responseType: "json",
    headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + userToken,
    },
});



export const getData = async (endpoint) => {
    try {
        const response = await axiosConfig.get(endpoint);
        return response.data
    } catch (error) {
        return error.response.data
    }
}


export const postData = async (endpoint, body) => {
    try {
        const response = await axiosConfig.post(endpoint, body)
        return response?.data
    } catch (error) {
        return error.response.data
    }
};

